import { render, staticRenderFns } from "./QuotePax.vue?vue&type=template&id=bf7c57a2&scoped=true"
import script from "./QuotePax.vue?vue&type=script&lang=js"
export * from "./QuotePax.vue?vue&type=script&lang=js"
import style0 from "./QuotePax.vue?vue&type=style&index=0&id=bf7c57a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7c57a2",
  null
  
)

export default component.exports